import { Form, Image, OverlayTrigger } from "react-bootstrap"
import BaseControl from "./BaseControl"
import Label from "./Label"
import ProfileImage from "./ProfileImage"

let defaultImageChaged: any| null = null

const InputItem = ({
    id="", 
    text="Text", 
    caption="", 
    value="", 
    edit=true,
    isImage=false,
    type="text",
    inputSize=4,
    loading=false,
    onImageChanged=defaultImageChaged,
    onChanged=(id:string, val:string)=>{}}) => {
    const _onImageChanged = (file:File) => {
        if (onImageChanged) {
            onImageChanged(file)
        }
        //onChanged(id, id)
    }
    return <BaseControl text={text} caption={caption} contentSize={inputSize}>
        <>
        { (!isImage || (isImage && !onImageChanged)) && edit && <Form.Control id={id} type={type} style={{height:'25px'}} 
            defaultValue={value} 
            onChange={e => onChanged(id, e.target.value)}/>}
        
        { isImage && onImageChanged && edit && 
            <OverlayTrigger overlay={<Image style={{backgroundColor:'white'}} src={value} height={100}/>}>
                {({ref, ...triggerHandler}) => (
                    <ProfileImage 
                        loading={loading} 
                        editable={edit} 
                        src={value} 
                        outline="none"
                        name={"NA"} size={30} bgcolor="rgb(217, 217, 217)" 
                        onChanged={_onImageChanged}/>  
                )}
            </OverlayTrigger>}

        { !isImage && !edit && 
            <Label fontWeight="400" textAlign='end' padding="">
                {type === 'number' || value.length < 20 ? value : value.substring(0,20) + "..."}
            </Label>}

        { isImage && !edit && 
            <OverlayTrigger overlay={<Image style={{backgroundColor:'white'}} src={value} height={100}/>}>
                {({ref, ...triggerHandler}) => (
                     <Image ref={ref} {...triggerHandler} src={value} height={20}/>
                )}
            </OverlayTrigger>}
        </>
    </BaseControl>
}

export default InputItem